import React from 'react'

import { withOnlyBrowser } from '../Device'
import AdLoader from './AdLoader'
import { withEmptyFallbackErrorBoundary } from '../error/EmptyFallbackErrorBoundary'

const AdVideo = withEmptyFallbackErrorBoundary(
  withOnlyBrowser(({ adName = 'ad_video' }) => (
    <div>
      <AdLoader adName={adName} />
    </div>
  ))
)

export default AdVideo
